import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { getNormalPerformanceAutoRefreshWarningState } from "../contributors-data-integrator.utils"

const NORMAL_PERFORMANCE_NO_LIVE_PRICING_REFRESH_WARNING = "Extended date mode — live performance updates paused for ranges over 1 month. Switch to a shorter window for live updates or click to refresh."

/**
 * Shared across all mounted instances so that simultaneous callers (e.g. performance,
 * summary, and factors-performance templates) cannot each dispatch the same toast in the
 * same React flush.
 */
let _hasShownWarning = false

/**
 * Toast when the dashboard range is too long for gated normal-performance refresh while a
 * `performance*` contributor gatherer exists. (non-intraday gatherers only)
 */
export function useNormalPerformancePricingRefreshWarning({
  gatherers,
  startDate,
  endDate,
  enabled = true,
}) {
  const dispatch = useDispatch()

  const nonIntradayGatherers = useMemo(
    () => (gatherers || []).filter((gatherer) => gatherer.type !== "intraday"),
    [gatherers],
  )

  useEffect(() => {
    if (!enabled) {
      return
    }
    const { shouldShowWarning, nextHasShownWarning } = getNormalPerformanceAutoRefreshWarningState({
      nonIntradayGatherers,
      startDate,
      endDate,
      hasShownWarning: _hasShownWarning,
    })

    _hasShownWarning = nextHasShownWarning

    if (shouldShowWarning) {
      dispatch(NotificationCreators.add("warning", null, NORMAL_PERFORMANCE_NO_LIVE_PRICING_REFRESH_WARNING))
    }
  }, [dispatch, enabled, endDate, nonIntradayGatherers, startDate])
}
